window.$breakpoints = {
    "xs": getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xs'),
    "sm": getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-sm'),
    "md": getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-md'),
    "lg": getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-lg'),
    "xl": getComputedStyle(document.documentElement).getPropertyValue('--breakpoint-xl'),
};
// console.log($breakpoints);

